'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
const DeployProjectWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/DeployProjectWizard'));
export default function withDeployProjectWizard(WrappedComponent) {
  class HighOrderWithDeployProjectWizard extends Component {
    constructor(props) {
      super(props);

      this.componentDidUpdate = prevProps => {
        if (this.props.folderId !== prevProps.folderId) {
          this.setState({
            folderId: this.props.folderId
          });
        }
      };

      this.handleDeployProjectCallback = () => {
        this.setState({
          open: false
        });
      };

      this.handleDeployProjectClick = () => {
        this.setState({
          open: true
        });
      };

      this.renderDeployProjectWizard = () => {
        if (!this.state.open) {
          return null;
        }

        return /*#__PURE__*/_jsx(DeployProjectWizard, {
          callback: this.handleDeployProjectCallback,
          folderId: this.state.folderId
        });
      };

      this.state = {
        open: false,
        folderId: props.folderId
      };
    }

    render() {
      const renderedDeployProjectWizard = this.renderDeployProjectWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        DeployProjectWizard: renderedDeployProjectWizard,
        onDeployProjectClick: this.handleDeployProjectClick
      }));
    }

  }

  HighOrderWithDeployProjectWizard.propTypes = {
    folderId: FolderPropTypes.folderId
  };
  HighOrderWithDeployProjectWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithDeployProjectWizard;
}